import { selectors } from 'publisher/reducers/webinarReducer'
import { shallowEqual, useSelector } from 'react-redux'

export { selectors }

export default function useWebinar(selector) {
  return useSelector(state => selector(state.webinar), shallowEqual)
}
